module.exports = __webpack_public_path__ + "img/avatar6.73681d9d.png";